import {
  AddIcon,
  DeleteIcon,
  TextButton,
} from '@maersktankersdigital/web-components'
import { Box, Typography } from '@mui/material'
import { useEffect, useState } from 'react'
import { IQuestionnaireField } from '~api/vessels/read'
import { InputDisplayRenderer } from './input-display'
import { Field } from './open-section-modal'

interface AddCommentProps extends IQuestionnaireField {
  inputData: Field[] | undefined
  onChangeHandler: (comment: string) => void
  isDisabled?: boolean
}

export function AddComment({
  inputData,
  onChangeHandler,
  id,
  comments,
  isDisabled,
}: AddCommentProps) {
  const [isEditing, setIsEditing] = useState<boolean>()
  const [commentFieldInput, setCommentFieldInput] = useState<
    string | undefined
  >('')
  const [isDeleting, setIsDeleting] = useState<boolean>()
  const savedComment = comments?.[0]?.value

  useEffect(() => {
    const comment =
      inputData?.find((i) => i.id === id)?.comment === undefined
        ? comments?.[0]?.value
        : inputData?.find((i) => i.id === id)?.comment

    setCommentFieldInput(comment?.toString() || '')
  }, [comments, inputData])

  const toggleEditing = () => {
    setIsEditing(!isEditing)
  }

  useEffect(() => {
    if (isEditing || isDeleting) return

    if (savedComment) {
      onChangeHandler(savedComment.toString())
    }
  }, [isEditing, isDeleting])

  return (
    <>
      {!isDisabled && ((!isEditing && !savedComment) || isDeleting) && (
        <Box
          component={TextButton}
          onClick={() => {
            setIsEditing(!isEditing)
            setIsDeleting(false)
          }}
          icon={<AddIcon width="16px" height="16px" />}
          sx={{ pl: 0 }}
        >
          Add comment
        </Box>
      )}
      {!isDeleting && (
        <Box>
          {(isEditing || savedComment) && (
            <>
              <Typography variant="graphCaption">Comment</Typography>
              <InputDisplayRenderer
                isEditingComment={!!isEditing}
                userName={comments?.[0]?.authorName || ''}
                createdAt={comments?.[0]?.createdAt || ''}
                toggleEditing={toggleEditing}
                comment={commentFieldInput}
                onChangeHandler={onChangeHandler}
                disableEdit={isDisabled}
              />
            </>
          )}
          {!isDisabled && savedComment && (
            <Box
              component={TextButton}
              variant="warning"
              onClick={() => {
                onChangeHandler('')
                setIsDeleting(true)
                setIsEditing(false)
              }}
              icon={<DeleteIcon width="16px" height="16px" />}
              sx={{ pl: 0 }}
            >
              Delete
            </Box>
          )}
        </Box>
      )}
    </>
  )
}
